@if (isLoadingCompleted) {
  <section class="access-denied-shell" aria-labelledby="access-denied-title">
    <span class="access-denied-orb access-denied-orb--left" aria-hidden="true"></span>
    <span class="access-denied-orb access-denied-orb--right" aria-hidden="true"></span>
    <span class="access-denied-grid" aria-hidden="true"></span>

    <div class="access-denied-content">
      <p class="access-denied-eyebrow">APP LIBRARY</p>

      <div class="access-denied-art" aria-hidden="true">
        <img src="images/access_denied.jpg" alt="" />
      </div>

      <h1 id="access-denied-title">Something went wrong</h1>
      <p class="access-denied-copy">
        Oops! We couldn’t load this screen right now. This usually clears up after a refresh, but if the issue keeps
        showing up, please try again or contact your administrator.
      </p>

      <div class="access-denied-actions">
        <button
          class="access-denied-primary"
          mat-flat-button
          aria-label="Reload page"
          matTooltip="Reload"
          (click)="reloadPage()"
        >
          Reload
        </button>
        <button
          class="access-denied-secondary"
          mat-button
          aria-label="Logout"
          matTooltip="Logout"
          (click)="logout()"
        >
          Logout
        </button>
      </div>
    </div>
  </section>
}
